import { defineAsyncComponent } from "vue";
import { has, have } from "../../../../utils/menu-context";
import { openModalListThNo } from "../user-company/user-company.logic";
import { Button } from "ant-design-vue";
import i18n from "../../../../i18n";
import { callCompanyProductStatus } from "./company-product.logic";
import { callCompanyCountryStatus } from "./company-country.logic";
import lodash from "lodash";
import store from "../../../../store";
import { callConfirmStatus } from "../company/company.section";

const CIcon = defineAsyncComponent(() => import("../../../../components/icon/CIcon"));

export const createConditionAction = () => {
    return {
        canEdit: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (!has({ menuContext, key: "canEdit" }) || record.isActive === false) return false;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forCompany" })) {
                result = [undefined, "Draft", "Re Edit"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompanyReceive" })) {
                if (record.createBy === userInfo.username) {
                    result = ["Draft"].includes(record.refStatus?.key) || result;
                }
                result = ["Wait"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompanyReview" })) {
                if (record.createBy === userInfo.username) {
                    result = ["Draft"].includes(record.refStatus?.key) || result;
                }
                result = ["Wait Review"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompanyApprove" })) {
                if (record.createBy === userInfo.username) {
                    result = ["Draft"].includes(record.refStatus?.key) || result;
                }
                result = ["Wait Approve", "Approve", "Reject"].includes(record.refStatus?.key) || result;
                if (["4", "6"].includes(record.refCompanyRequestType?.key)) {
                    result = false;
                }
            }
            return result;
        },
        canSendWait: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            const userInfo = store.state.resource.auth.info?.user;
            if (has({ menuContext, key: "forCompany" })) {
                result = ["Draft", "Re Edit"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompanyReceive" })) {
                if (record.createBy === userInfo.username) {
                    result = ["Draft", "Re Edit"].includes(record.refStatus?.key) || result;
                }
            }
            if (has({ menuContext, key: "forCompanyReview" })) {
                if (record.createBy === userInfo.username) {
                    result = ["Draft", "Re Edit"].includes(record.refStatus?.key) || result;
                }
            }
            if (has({ menuContext, key: "forCompanyApprove" })) {
                if (record.createBy === userInfo.username) {
                    result = ["Draft", "Re Edit"].includes(record.refStatus?.key) || result;
                }
            }
            return result;
        },
        canSendWaitApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompanyReview" })) {
                result = ["Wait Review"].includes(record.refStatus?.key) || result;
            }
            return result;
        },
        canApprove: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompanyApprove" })) {
                result = ["Wait Approve"].includes(record.refStatus?.key) || result;
            }
            if (has({ menuContext, key: "forCompanyReview" })) {
                if (["4", "6"].includes(record.refCompanyRequestType?.key)) {
                    result = ["Wait Approve"].includes(record.refStatus?.key) || result;
                }
            }
            return result;
        },
        canCancel: ({ record }) => {
            let result = false;
            result = !["Draft", "Approve", "Reject", "Cancel"].includes(record.refStatus?.key) || result;
            return result;
        },
        canReportChangeAddress: ({ props, record }) => {
            let result = false;
            const { menuContext } = props;
            if (has({ menuContext, key: "forCompanyApprove" })) {
                if (["Wait Approve", "Approve", "Reject"].includes(record.refStatus?.key)) {
                    result = ["8"].includes(record.refCompanyRequestType?.key) || result;
                }
            }
            return result;
        }
    };
};

export const createConditionForm = () => {
    return [
        {
            check: ({ field }) => {
                return ["refCompany"].includes(field?.key);
            },
            inputPropField: ({ modelRef }) => {
                return {
                    "onUpdate:value": value => {
                        modelRef.refCompany = value;
                        modelRef.refCompanyRequestType = null;
                    }
                };
            }
        },
        {
            check: ({ field }) => {
                return ["refCompanyRequestType"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef }) => {
                const { viewOnly } = props;
                return { disabled: !modelRef.refCompany || viewOnly };
            }
        },
        {
            check: ({ field }) => {
                return (
                    field?.key?.startsWith("refCompanyTmp.companyAttachments.") &&
                    (field?.key?.endsWith(".checked") || field?.key?.endsWith(".attachments"))
                );
            },
            checkedProp: ({ props, data, modelRef, initialModel, items, item, keyAttachment, keyExpiredDate }) => {
                const { viewOnly } = props;
                const { useForm } = data;
                let enabled = false;
                let onUpdateCheck = undefined;
                if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                    if (["1", "2"].includes(modelRef.refCompanyRequestType?.key)) {
                        const attribute = item.refCompanyAttachmentType?.attribute;
                        let otherCheckInGroup = false;
                        if (attribute?.checkGroup) {
                            otherCheckInGroup = items.find(d => {
                                return (
                                    d.refCompanyAttachmentType.id !== item.refCompanyAttachmentType.id &&
                                    d.refCompanyAttachmentType.attribute?.checkGroup === attribute?.checkGroup &&
                                    d.isChecked
                                );
                            });
                        }
                        enabled =
                            (item.refCompanyAttachmentType.attribute?.canCheck &&
                                !viewOnly &&
                                (!item.isChecked || (item.isChecked && item.isAdditional)) &&
                                !otherCheckInGroup) ||
                            enabled;
                        onUpdateCheck = checked => {
                            item.isSave = true;
                            item.isAdditional = true;
                            item.isChecked = checked;
                            if (!checked) {
                                useForm.validate([keyAttachment, keyExpiredDate]).catch(() => {});
                                item.expiredDate = null;
                                lodash.remove(item.attachments, d => !d.id);
                                item.attachments.forEach(d => (d.isDelete = true));
                            }
                        };
                    }
                }
                return { disabled: !enabled, "onUpdate:checked": onUpdateCheck };
            },
            attachmentProp: ({ modelRef, initialModel }) => {
                let showDelete = () => false;
                let attribute = undefined;
                let onReplaceValue = undefined;
                if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                    if (["1", "2"].includes(modelRef.refCompanyRequestType?.key)) {
                        showDelete = ({ file }) => file.attribute?.isAdditional;
                        attribute = { isAdditional: true };
                        onReplaceValue = ({ oldFile, newFile }) => {
                            newFile.attribute = oldFile.attribute;
                        };
                    }
                }
                return { showDelete, attribute, "onReplace:value": onReplaceValue };
            }
        },
        {
            check: ({ field }) => {
                return ["receiveDatetime", "remark"].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyReceive" })) {
                    if (["Wait"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refStatus"].includes(field?.key);
            },
            inputPropField: ({ props, data, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                let value = undefined;
                if (has({ menuContext, key: "forCompanyReceive" })) {
                    if (["Wait"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (["Wait Approve", "Approve", "Reject"].includes(initialModel.refStatus?.key)) {
                    value = data.statuses.find(d => d.key === "Wait Review");
                }
                return { disabled: !enabled, value };
            }
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refCompanyTmp.companyProducts.") && field?.key?.endsWith(".refStatus");
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext } = props;
                let list = undefined;
                if (have({ menuContext, key: ["forCompanyReview", "forCompanyApprove"] })) {
                    if (["Wait Review", "Wait Approve"].includes(initialModel.refStatus?.key)) {
                        if (["1", "2", "3"].includes(modelRef.refCompanyRequestType?.key)) {
                            list = ({ searchQuery }) =>
                                callCompanyProductStatus({ searchQuery }).then(statuses =>
                                    statuses.filter(d => !["Draft", "Suspend"].includes(d.key))
                                );
                        }
                    }
                }
                return { list };
            }
        },
        {
            check: ({ field }) => {
                return field?.key?.startsWith("refCompanyTmp.companyCountries.") && field?.key?.endsWith(".refStatus");
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext } = props;
                let list = undefined;
                if (have({ menuContext, key: ["forCompanyReview", "forCompanyApprove"] })) {
                    if (["Wait Review", "Wait Approve"].includes(initialModel.refStatus?.key)) {
                        if (["1", "2", "5"].includes(modelRef.refCompanyRequestType?.key)) {
                            list = ({ searchQuery }) =>
                                callCompanyCountryStatus({ searchQuery }).then(statuses =>
                                    statuses.filter(d => !["Draft", "Wait", "Approve", "Suspend", "Cancel"].includes(d.key))
                                );
                        }
                    }
                }
                return { list };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refCompanyTmp.companyInspections.0.inspectionStartDatetime",
                    "refCompanyTmp.companyInspections.0.inspectionEndDatetime",
                    "refCompanyTmp.companyInspections.0.inspector",
                    "refCompanyTmp.companyInspections.0.c",
                    "refCompanyTmp.companyInspections.0.se",
                    "refCompanyTmp.companyInspections.0.m",
                    "refCompanyTmp.companyInspections.0.n",
                    "refCompanyTmp.companyInspections.0.refGmpStatus",
                    "refCompanyTmp.companyInspections.0.refHaccpStatus",
                    "refCompanyTmp.companyInspections.0.remark"
                ].includes(field?.key);
            },
            inputPropField: ({ props, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompanyReview" })) {
                    if (["Wait Review"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                if (has({ menuContext, key: "forCompanyApprove" })) {
                    if (["Wait Approve"].includes(initialModel.refStatus?.key)) {
                        enabled = !viewOnly || enabled;
                    }
                }
                return { disabled: !enabled };
            }
        },
        {
            check: ({ field }) => {
                return ["refCompanyTmp.companyInspections.0.refInspector"].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return [
                    "refCompanyTmp.companyInspections.0.refInspectionType",
                    "refCompanyTmp.companyInspections.0.isInvestFollowup",
                    "refReceiver.fullName"
                ].includes(field?.key);
            },
            inputPropField: () => {
                return { disabled: true };
            }
        },
        {
            check: ({ field }) => {
                return ["refCompanyTmp.thNo"].includes(field?.key);
            },
            inputPropField: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let addonAfter = undefined;
                let buttonRemove = undefined;
                if (has({ menuContext, key: "forCompanyApprove" })) {
                    if (["Wait Approve"].includes(initialModel.refStatus?.key)) {
                        if (!viewOnly && modelRef.refCompanyTmp.thNo) {
                            buttonRemove = (
                                <Button class="mr-2" size="small" onClick={() => (modelRef.refCompanyTmp.thNo = null)}>
                                    <CIcon file="close.svg"></CIcon>
                                </Button>
                            );
                        }
                        addonAfter = () => {
                            return (
                                <>
                                    {buttonRemove}
                                    <Button
                                        class="btn-primary"
                                        disabled={viewOnly}
                                        size="small"
                                        onClick={() => {
                                            callConfirmStatus({}).then(statuses => {
                                                openModalListThNo({
                                                    onIframeMounted: ({ refs, options }) => {
                                                        refs.iframe.contentWindow.onSelect = ({ rowSelection }) => {
                                                            modelRef.refCompanyTmp.thNo = rowSelection.selectedRows?.[0]?.refCompany?.thNo;
                                                            options.bind.onCancel();
                                                        };
                                                        refs.iframe.contentWindow.onInitState = ({ state }) => {
                                                            const column = state.columns.find(d => d.dataIndex === "refCompany.refStatus.value");
                                                            column.search.field.searchValue = statuses.find(d => d.key === "Cancel");
                                                        };
                                                    }
                                                });
                                            });
                                        }}
                                    >
                                        <CIcon file="search.svg"></CIcon>
                                    </Button>
                                </>
                            );
                        };
                    }
                }
                return { disabled: true, addonAfter };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyRequest"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                return !modelRef.refCompanyTmp;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyRequestHeader", "SomeInfomationView"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                return modelRef.refCompanyTmp;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyUser"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { menuContext } = props;
                let result = false;
                if (modelRef.refCompanyTmp) {
                    if (has({ menuContext, key: "forCompany" })) {
                        if (["9"].includes(modelRef.refCompanyRequestType?.key)) {
                            if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                                result = true || result;
                            }
                        }
                    }
                }
                return result;
            },
            enable: ({ props }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                if (has({ menuContext, key: "forCompany" })) {
                    enabled = !viewOnly || enabled;
                }
                return enabled;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Attachment"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                return modelRef.refCompanyTmp;
            },
            cardProp: ({ modelRef }) => {
                let title = undefined;
                if (["3", "4", "5", "6", "7", "8", "9"].includes(modelRef.refCompanyRequestType?.key)) {
                    title = i18n.global.t("views.company.companyRequest.type3.attachment.title");
                }
                return { title };
            },
            componentProp: ({ props, initialModel }) => {
                const { menuContext } = props;
                let menuContextClone = lodash.cloneDeep(menuContext);
                lodash.remove(menuContextClone.attribute, d => d === "canView");
                if (have({ menuContext, keys: ["forCompanyReceive", "forCompanyReview", "forCompanyApprove"] })) {
                    if (["Wait", "Wait Review", "Wait Approve", "Approve", "Reject"].includes(initialModel.refStatus?.key)) {
                        if (!has({ menuContext, key: "canDelete" })) {
                            menuContextClone.attribute.push("canDelete");
                        }
                        lodash.remove(menuContextClone.attribute, d => d === "canCreate");
                        lodash.remove(menuContextClone.attribute, d => d === "canEdit");
                    }
                }
                return { menuContext: menuContextClone };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyProduct"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    result = ["1", "2", "3", "4", "7"].includes(modelRef.refCompanyRequestType?.key) || result;
                }
                return result;
            },
            cardProp: ({ modelRef }) => {
                let title = undefined;
                if (["1", "2", "3"].includes(modelRef.refCompanyRequestType?.key)) {
                    title = i18n.global.t("views.company.companyRequest.type1.companyProduct.title");
                } else if (["4"].includes(modelRef.refCompanyRequestType?.key)) {
                    title = i18n.global.t("views.company.companyRequest.type4.companyProduct.title");
                }
                return { title };
            },
            componentProp: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                let enabledCheckPrivilege = false;
                let enabledCheckReject = false;
                let enabledSamplingCondition = false;
                let enabledSamplingFrequencyType = false;
                let enabledStatus = false;
                let enabledRemark = false;
                let visibleCheckPrivilege = false;
                let visibleCheckReject = false;
                let visibleSamplingCondition = false;
                let visibleSamplingFrequencyType = false;
                let visibleIsSuspendedSampling = false;
                let visibleIsSuspendedHc = false;
                let visibleDocRejectStatus = false;
                if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                    enabledRemark = !viewOnly || enabledRemark;
                    if (["4"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabled = false;
                        enabledCheckReject = !viewOnly || enabledCheckReject;
                        visibleCheckReject = true;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabled = false;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                }
                if (has({ menuContext, key: "forCompany" })) {
                    if (["4"].includes(modelRef.refCompanyRequestType?.key)) {
                        visibleCheckReject = true;
                    }
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        if (initialModel.refStatus?.key === "Approve") {
                            visibleCheckPrivilege = true;
                        }
                    }
                }
                if (has({ menuContext, key: "forCompanyReceive" })) {
                    if (["4"].includes(modelRef.refCompanyRequestType?.key)) {
                        visibleCheckReject = true;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                }
                if (has({ menuContext, key: "forCompanyReview" })) {
                    if (["Wait Review"].includes(initialModel.refStatus?.key)) {
                        enabledStatus = !viewOnly || enabledStatus;
                    }
                    if (["1", "2"].includes(modelRef.refCompanyRequestType?.key)) {
                        if (["Wait Review"].includes(initialModel.refStatus?.key)) {
                            enabledSamplingCondition = !viewOnly || enabledSamplingCondition;
                            enabledSamplingFrequencyType = !viewOnly || enabledSamplingFrequencyType;
                        }
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                    if (["4"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabledStatus = false;
                        visibleCheckReject = true;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        if (["Wait Review"].includes(initialModel.refStatus?.key)) {
                            enabledCheckPrivilege = !viewOnly || enabledCheckPrivilege;
                        }
                        enabledStatus = false;
                        visibleCheckPrivilege = true;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                }
                if (has({ menuContext, key: "forCompanyApprove" })) {
                    if (["Wait Approve"].includes(initialModel.refStatus?.key)) {
                        enabledStatus = !viewOnly || enabledStatus;
                    }
                    if (["1", "2"].includes(modelRef.refCompanyRequestType?.key)) {
                        if (["Wait Approve"].includes(initialModel.refStatus?.key)) {
                            enabledSamplingCondition = !viewOnly || enabledSamplingCondition;
                            enabledSamplingFrequencyType = !viewOnly || enabledSamplingFrequencyType;
                        }
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                    if (["4"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabledStatus = false;
                        visibleCheckReject = true;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                    if (["7"].includes(modelRef.refCompanyRequestType?.key)) {
                        if (["Wait Approve"].includes(initialModel.refStatus?.key)) {
                            enabledCheckPrivilege = !viewOnly || enabledCheckPrivilege;
                        }
                        enabledStatus = false;
                        visibleCheckPrivilege = true;
                        visibleSamplingCondition = true;
                        visibleSamplingFrequencyType = true;
                    }
                }
                return {
                    viewOnly: !enabled,
                    disabledCheckPrivilege: !enabledCheckPrivilege,
                    disabledCheckReject: !enabledCheckReject,
                    disabledSamplingCondition: !enabledSamplingCondition,
                    disabledSamplingFrequencyType: !enabledSamplingFrequencyType,
                    disabledStatus: !enabledStatus,
                    disabledRemark: !enabledRemark,
                    visibleCheckPrivilege,
                    visibleCheckReject,
                    visibleSamplingCondition,
                    visibleSamplingFrequencyType,
                    visibleIsSuspendedSampling,
                    visibleIsSuspendedHc,
                    visibleDocRejectStatus
                };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyCountry"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    result = ["1", "2", "5", "6"].includes(modelRef.refCompanyRequestType?.key) || result;
                }
                return result;
            },
            cardProp: ({ modelRef }) => {
                let title = undefined;
                if (["1", "2", "5"].includes(modelRef.refCompanyRequestType?.key)) {
                    title = i18n.global.t("views.company.companyRequest.type1.companyCountry.title");
                } else if (["6"].includes(modelRef.refCompanyRequestType?.key)) {
                    title = i18n.global.t("views.company.companyRequest.type6.companyCountry.title");
                }
                return { title };
            },
            componentProp: ({ props, modelRef, initialModel }) => {
                const { menuContext, viewOnly } = props;
                let enabled = false;
                let enabledCheckReject = false;
                let enabledStatus = false;
                let visibleCheckReject = false;

                if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                    if (["6"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabled = false;
                        enabledCheckReject = !viewOnly || enabledCheckReject;
                        visibleCheckReject = true;
                    }
                }
                if (has({ menuContext, key: "forCompany" })) {
                    if (["6"].includes(modelRef.refCompanyRequestType?.key)) {
                        visibleCheckReject = true;
                    }
                }
                if (has({ menuContext, key: "forCompanyReceive" })) {
                    if (["6"].includes(modelRef.refCompanyRequestType?.key)) {
                        visibleCheckReject = true;
                    }
                }
                if (has({ menuContext, key: "forCompanyReview" })) {
                    if (["Wait Review"].includes(initialModel.refStatus?.key)) {
                        enabledStatus = !viewOnly || enabledStatus;
                    }
                    if (["6"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabledStatus = false;
                        visibleCheckReject = true;
                    }
                }
                if (has({ menuContext, key: "forCompanyApprove" })) {
                    if (["Wait Approve"].includes(initialModel.refStatus?.key)) {
                        enabledStatus = !viewOnly || enabledStatus;
                    }
                    if (["6"].includes(modelRef.refCompanyRequestType?.key)) {
                        enabledStatus = false;
                        visibleCheckReject = true;
                    }
                }
                return {
                    viewOnly: !enabled,
                    disabledCheckReject: !enabledCheckReject,
                    disabledStatus: !enabledStatus,
                    visibleCheckReject
                };
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyAddress"].includes(sectionKey);
            },
            visibleSection: ({ modelRef, initialModel }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                        result = ["8"].includes(modelRef.refCompanyRequestType?.key) || result;
                    }
                }
                return result;
            },
            enable: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return enabled;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyAddressCompare"].includes(sectionKey);
            },
            visibleSection: ({ modelRef, initialModel }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    if (![undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                        result = ["8"].includes(modelRef.refCompanyRequestType?.key) || result;
                    }
                }
                return result;
            },
            enable: () => {
                return false;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyUserCompare"].includes(sectionKey);
            },
            visibleSection: ({ modelRef, initialModel }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    if (![undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                        result = ["9"].includes(modelRef.refCompanyRequestType?.key) || result;
                    }
                }
                return result;
            },
            enable: () => {
                return false;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyAttachment"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    result = ["1", "2"].includes(modelRef.refCompanyRequestType?.key) || result;
                }
                return result;
            },
            enable: ({ props, initialModel }) => {
                const { viewOnly } = props;
                let enabled = false;
                if ([undefined, "Draft", "Re Edit"].includes(initialModel.refStatus?.key)) {
                    enabled = !viewOnly || enabled;
                }
                return enabled;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["CompanyInspection", "SamplingProduct", "CompanyCert"].includes(sectionKey);
            },
            visibleSection: ({ modelRef }) => {
                let result = false;
                if (modelRef.refCompanyTmp) {
                    result = ["7"].includes(modelRef.refCompanyRequestType?.key) || result;
                }
                return result;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Receive"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { menuContext } = props;
                let result = false;
                if (modelRef.refCompanyTmp) {
                    if (![undefined, "Draft"].includes(initialModel.refStatus?.key)) {
                        if (have({ menuContext, keys: ["forCompanyReceive", "forCompanyReview", "forCompanyApprove"] })) {
                            result = true || result;
                        }
                        if (has({ menuContext, key: "forCompany" })) {
                            result = modelRef.refReceiver || result;
                        }
                    }
                }
                return result;
            }
        },
        {
            check: ({ sectionKey }) => {
                return ["Inspection"].includes(sectionKey);
            },
            visibleSection: ({ props, modelRef, initialModel }) => {
                const { menuContext } = props;
                let result = false;
                if (modelRef.refCompanyTmp?.companyInspections?.length > 0) {
                    if (["1", "2"].includes(modelRef.refCompanyRequestType?.key)) {
                        if (["Wait Review", "Wait Approve"].includes(initialModel.refStatus?.key)) {
                            if (have({ menuContext, keys: ["forCompanyReview", "forCompanyApprove"] })) {
                                result = true || result;
                            }
                        }
                    }
                }
                return result;
            }
        }
    ];
};
